import React, { useState, useEffect } from 'react';
import '../../../css/createRole/RoleManagement.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import DeleteAssignRoleModal from '../../shared/DeleteAssignRoleModal';
import DeleteModal from '../../shared/DeleteRoleModal';
import Sidenav from '../../shared/Sidenav';
import SameRoleModal from '../../shared/DeleteAssignRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { ALLROLES_ENDPOINT, ADDROLE_ENDPOINT, DELETEROLE_ENDPOINT, UPDATEROLE_ENDPOINT, TILEPREMISSION_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { useSelector } from 'react-redux';
import viewAccessImg from '../../../assets/images/viewOnlyAccess.svg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function RoleManagement() {
   const [hasOpen, setHasOpen] = useState(false);
   const [hasOpenDelete, setHasOpenDelete] = useState(false);
   const [addRolename, setAddRolename] = useState(false);
   const [isEdit, setIsEdit] = useState([]);
   const [showRoleTypeDropdown, setShowRoleTypeDropdown] = useState(false);
   const [premiumAccess, setPremiumAccess] = useState([]);
   const [showDetail, setShowDetail] = useState([false]);
   const [roleType, setRoleType] = useState("");
   const [roleName, setRoleName] = useState('');
   const [sameRoleHasOpen, setSameRoleHasOpen] = useState(false);
   const [data, setData] = useState([]);
   const [confirmedHasOpen, setConfirmedHasOpen] = useState(false);
   const [deleteIndexExternal, setDeleteIndexExternal] = useState('');
   const [editRoleName, setEditRoleName] = useState('');
   const [editIndex, setEditIndex] = useState('');
   const container = React.createRef();
   const [permissionChanges, setPermissionChanges] = useState({});
   const [tileName, setTileName] = useState([]);
   const [viewAccess, setViewAccess] = useState([]);
   const [viewEditAccess, setViewEditAccess] = useState([]);
   var selectedTiles = [];
   let viewOnly = false;
   let roleData = useSelector(state => state.adminRoleReducer.roleData)
   const roleDataLength = roleData.length;
   for (let z = 0; z < roleDataLength; z++) {
      var rd = roleData[z].permissions;
      selectedTiles.push(rd)
   }
   selectedTiles.map(x =>
      x.map(md => {
         if (md.functionId == 13) {
            if (md.method.includes("View & Edit")) {
               viewOnly = true
            }
         }
      }))
   useEffect(() => {
      let unmounted = false;
      let pta = {};
      ApiCall(
         'GET',
         baseURL + ALLROLES_ENDPOINT,
         {},
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         },
      ).then((apiData) => {
         if (!unmounted) {
            if (apiData.flag !== -1) {
               if (apiData.flag === 500) {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
               else {
                  console.log('I am 200!');
                  setData(apiData);
               }
            } else {
               // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
         }
      });
      // API Call
      ApiCall(
         'GET',
         baseURL + TILEPREMISSION_ENDPOINT,
         {},
         {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         }
      ).then(apiData => {
         if (!unmounted) {
            if (apiData.flag !== -1) {
               if (apiData.flag === 500) {
                  console.log('I am 500!');
               }
               else {
                  console.log('I am 200!');
                  console.log(apiData);
                  setTileName(apiData);
                  // checkbox logic
                  if (apiData.length > 0) {
                     apiData.forEach((s) => {
                        pta[s.functionId] = false;
                        console.log('tile')
                     })
                     console.log(pta, "preview")
                  }
               }
            }
            else {
               //  toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
         }
      })
      return () => { unmounted = true };
   }, [])
   const recordInitialRoleWisePermission = (roleId, permissions, index, openRequested = false) => {
      // recording initial permissions when drop down is opening for a particular role type 
      if (Object.keys(permissionChanges).indexOf(roleId) == -1) {
         let pc = permissionChanges;
         pc[roleId] = permissions;
         setPermissionChanges(pc);
      }
   }
   const confirmHandler = (index) => {
      // updating the changes in master data to be puched to server
      console.log('confirm requested');
      console.log(permissionChanges);
      console.log("editRoleName=", editRoleName)
      let pc = permissionChanges;
      let updatedRoleIds = Object.keys(pc);
      data.map((d, key) => {
         if (updatedRoleIds.indexOf(d.roleId) != -1) {
            d.permissions = pc[d.roleId];
         }
         return d
      });
      console.log(data[index]);
      console.log("ss", data[index].name);
      //edit role api call goes here
      ApiCall(
         'PUT',
         baseURL + UPDATEROLE_ENDPOINT,
         data[index],
         {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         }
      ).then(apiData => {
         if (apiData.flag !== -1) {
            if (apiData.flag === 500) {
               toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
               console.log('I am 200!');
               setConfirmedHasOpen(true);
            }
         }
         else {
            // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
         }
      })
   }
   const updateRoleViewPremission = (rowindex, roleIndex) => {
      //updating the permissions for a particular function of a roleType
      let roleId = tileName[rowindex].functionId;
      if (data[roleIndex].permissions.filter(x => x.functionId == roleId && x.method == "View").length > 0) {
         console.log('view present');
         let profileRoles = data[roleIndex].permissions;
         profileRoles = profileRoles.filter(p => p.functionId != roleId);
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
         console.log("if view", userDetails);
      }
      else {
         let profileRoles = data[roleIndex].permissions;
         let r = tileName[rowindex];
         r = {
            functionId: r.functionId,
            function: r.function,
            functionMeaning: r.functionMeaning,
            functionDisplayName: r.functionDisplayName,
            method: "View",
            activeFromDate: r.activeFromDate,
            activeToDate: r.activeToDate,
         }
         profileRoles.push(r);
         profileRoles.filter(x => x.functionId == roleId ? x.method = "View" : "")
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
         console.log("else view", userDetails);
      }
      let profileRoles = data[roleIndex].permissions;
      var dups = [];
      var arr = profileRoles.filter(function (el) {
         // If it is not a duplicate, return true
         if (dups.indexOf(el.functionId) == -1) {
            dups.push(el.functionId);
            return true;
         }
         return false;
      });
      console.log(arr, "arr");
      data[roleIndex].permissions = arr
      console.log("upated view Dtat", data[roleIndex].permissions)
      return data[roleIndex].permissions
   }
   const updateRoleViewEditPremission = (rowindex, roleIndex) => {
      //updating the permissions for a particular function of a roleType
      let roleId = tileName[rowindex].functionId;
      if (data[roleIndex].permissions.filter(x => x.functionId == roleId && x.method == "View & Edit").length > 0) {
         console.log('view edit present');
         let profileRoles = data[roleIndex].permissions;
         profileRoles = profileRoles.filter(p => p.functionId != roleId);
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
      }
      else {
         let profileRoles = data[roleIndex].permissions;
         let r = tileName[rowindex];
         r = {
            functionId: r.functionId,
            function: r.function,
            functionMeaning: r.functionMeaning,
            functionDisplayName: r.functionDisplayName,
            method: "View & Edit",
            activeFromDate: r.activeFromDate,
            activeToDate: r.activeToDate,
         }
         profileRoles.push(r);
         profileRoles.filter(x => x.functionId == roleId ? x.method = "View & Edit" : "")
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
         console.log("else ve", userDetails);
      }
      let profileRoles = data[roleIndex].permissions;
      var dups = [];
      var arr = profileRoles.filter(function (el) {
         // If it is not a duplicate, return true
         if (dups.indexOf(el.functionId) == -1) {
            dups.push(el.functionId);
            return true;
         }
         return false;
      });
      data[roleIndex].permissions = arr
      return data[roleIndex].permissions
   }
   const handleClickOutside = event => {
      if (container.current && !container.current.contains(event.target)) {
         setShowRoleTypeDropdown(false);
      }
   };
   document.addEventListener("mousedown", handleClickOutside);
   const onCloseConfirmed = () => {
      setConfirmedHasOpen(false);
      window.location.reload();
   }
   const validateFormFields = () => {
      return roleType.length > 0 &&
         roleName.length > 0 && (
            premiumAccess.length > 0 || viewAccess.length > 0 || viewEditAccess.length > 0
         );
   };
   const validateEditFormFields = () => {
      return data[editIndex].name !== '' &&
         (data[editIndex].permissions.length > 0);
   };
   const getSelectedPermissionforAPI = () => {
      let selectedTerminalsforAPI = [];
      tileName.map((val, key) => {
         if (
            premiumAccess[key]
         ) {
            selectedTerminalsforAPI.push({
               functionId: tileName[key].functionId,
               function: tileName[key].function,
               functionMeaning: tileName[key].functionMeaning,
               functionDisplayName: tileName[key].functionDisplayName,
               method: premiumAccess[key] ? "View" : "",
               activeFromDate: tileName[key].activeFromDate,
               activeToDate: tileName[key].activeToDate,
            });
         }
      })
      return (selectedTerminalsforAPI);
   }
   const getSelectedPermissionforInternalUserAPI = () => {
      let selectedTerminalsforAPI = [];
      tileName.map((val, key) => {
         if (viewAccess[key] || viewEditAccess[key]) {
            selectedTerminalsforAPI.push({
               functionId: tileName[key].functionId,
               function: tileName[key].function,
               functionMeaning: tileName[key].functionMeaning,
               functionDisplayName: tileName[key].functionDisplayName,
               method: viewAccess[key] ? "View" : "" || viewEditAccess[key] ? "View & Edit" : "",
               activeFromDate: tileName[key].activeFromDate,
               activeToDate: tileName[key].activeToDate,
            });
         }
      })
      return (selectedTerminalsforAPI);
   }
   const addInternalRole = () => {
      if (data.find(e => (e.name.trim() == roleName.trim() || e.name.trim().toUpperCase() == roleName.trim() || e.name.trim().toLowerCase() == roleName.trim()) && e.type == roleType)) {
         setSameRoleHasOpen(true);
      }
      else {
         ApiCall(
            'POST',
            baseURL + ADDROLE_ENDPOINT,
            {
               "name": roleName,
               "permissions": getSelectedPermissionforInternalUserAPI(),
               "roleId": 0,
               "type": roleType
            },
            {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'x-cc-trace-id': '1234',
            }
         ).then(apiData => {
            if (apiData.flag !== -1) {
               if (apiData.flag === 500) {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
               else {
                  console.log('I am 200!');
                  setConfirmedHasOpen(true);
               }
            }
            else {
               // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }

         })
      }
   }
   const addExternalRole = () => {
      if (data.find(e => (e.name.trim() == roleName.trim() || e.name.trim().toUpperCase() == roleName.trim() || e.name.trim().toLowerCase() == roleName.trim()) && e.type == roleType)) {
         setSameRoleHasOpen(true);
      }
      else {
         ApiCall(
            'POST',
            baseURL + ADDROLE_ENDPOINT,
            {
               "name": roleName,
               "permissions": getSelectedPermissionforAPI(),
               "roleId": 0,
               "type": roleType
            },
            {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'x-cc-trace-id': '1234',
            }
         ).then(apiData => {
            if (apiData.flag !== -1) {
               if (apiData.flag === 500) {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
               else {
                  console.log('I am 200!');
                  setConfirmedHasOpen(true);
               }
            }
            else {
               // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
         })
      }
   }
   const updateRolePremission = (rowindex, roleIndex) => {
      //updating the permissions for a particular function of a roleType
      let roleId = tileName[rowindex].functionId;
      if (data[roleIndex].permissions.filter(x => x.functionId == roleId).length > 0) {
         console.log('present');
         let profileRoles = data[roleIndex].permissions;
         profileRoles = profileRoles.filter(p => p.functionId != roleId);
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
         console.log(userDetails);
      }
      else {
         let profileRoles = data[roleIndex].permissions;
         let r = tileName[rowindex];
         r = {
            functionId: r.functionId,
            function: r.function,
            functionMeaning: r.functionMeaning,
            functionDisplayName: r.functionDisplayName,
            method: r.method,
            activeFromDate: r.activeFromDate,
            activeToDate: r.activeToDate,
         }
         profileRoles.push(r);
         let userDetails = data;
         userDetails[roleIndex].permissions = profileRoles;
         console.log(userDetails);
      }
      console.log("upated Dtat", data[roleIndex].permissions)
      return data[roleIndex].permissions
   }
   const showAddRoleTypeDropdown = () => {
      setShowRoleTypeDropdown(true);
   }
   const showAddRoleName = () => {
      setAddRolename(true);
      var objDiv = document.getElementById("roletablescroll");
      objDiv.scrollTop = objDiv.scrollHeight;
   }
   const onCloseModal = () => {
      setHasOpen(false);
   }
   const onCloseSameRoleModal = () => {
      setSameRoleHasOpen(false);
   }
   const onCloseDeleteModal = () => {
      setHasOpenDelete(false);
   }
   const onDeleteRole = () => {
      ApiCall(
         'DELETE',
         baseURL + DELETEROLE_ENDPOINT + `?roleName=${data[deleteIndexExternal].name}`,
         {},
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         },
      ).then((apiData) => {
         if (apiData.flag !== -1) {
            if (apiData.flag === 500) {
               if (apiData.data.message == "Role doesn't exist") {
                  toast(message.alert.roleVarifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
               else {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
            }
            else {
               console.log('I am 200!');
               console.log(apiData.message);
               setConfirmedHasOpen(true);
               setHasOpenDelete(false);
            }
         } else {
            // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
         }
      });
   }
   const onDeleteExternalRole = (index) => {
      setDeleteIndexExternal(index);
      setHasOpenDelete(true)
   }
   const onEditExternalRole = (index) => {
      isEdit[index] = !isEdit[index];
      setIsEdit(isEdit);
      setEditIndex(index);
      setEditRoleName(data[index].name)
      let a = showDetail;
      a[index] = !showDetail[index];
      setShowDetail(a);
   }
   return (
      <div className="outer1" id="outerdiv" >
         <MetaDecorator title={TitleDescription.roleManagementPageTitle} description={TitleDescription.roleManagementPageDescription} />
         <div >
            <div className="screen">
               <div class=" home">
                  <div id="outerheader" >
                  </div>
                  <Sidenav />
                  <div class="roleManagementContainer" id="createRoleSection">
                     <p class="pt-2 pb-2" id="createRole">Create Role</p>
                     <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                        <img alt="View Only Access" src={viewAccessImg} />
                        <span className="viewOnly">View Only Access</span>
                     </div>
                     {
                        <div class="roleoutshadow">
                           <div class="rolelinetwo">
                              <div class="externalUserRoleType"><small class="rolelinetwosmall">Role Type</small></div>
                              <div class="externalUserRoleName"><small class="rolelinetwosmall">Role Name*</small></div>
                           </div>
                           <div id="roletablescroll">
                              {(data.map((name, index) => {
                                 return (
                                    <div id="roleData">
                                       <div>
                                          <div class="rolelinetable2even" id="roleData"
                                             style={{
                                                background: showDetail[index] ? "#FFFBF7" : "white",
                                                borderBottom: showDetail[index] ? "none" : null
                                             }}
                                          >
                                             <div class="rolelinetable">
                                                <div class="roleAccordion">
                                                   <img src={(showDetail[index]) ? require('../../../assets/images/accordion_up.svg') : require('../../../assets/images/accordion_down.svg')} width="21" height="21" class="d-inline-block"
                                                      onClick={() => {
                                                         let a = showDetail;
                                                         a[index] = !showDetail[index];
                                                         setShowDetail(a);
                                                         isEdit[index] = false;
                                                         setIsEdit(isEdit)
                                                      }}
                                                      id="" />
                                                </div>
                                                <div class="roleTypeDiv">
                                                   <small class="roleTypeSmallText">{name.type}</small>
                                                   <img src={require('../../../assets/images/drpdwnArrow.svg')} width="14" height="18" id="rolelineimg" class="d-inline-block mt-1" alt="" loading="lazy" />
                                                </div>
                                                <div class="roleNameDiv">
                                                   {isEdit[index] ?
                                                      <input type="text" class="roleaddinput" placeholder="Enter Role Name"
                                                         value={name.name}
                                                         onChange={(e) => {
                                                            data[index].name = e.target.value;
                                                            setData(data);
                                                         }}
                                                      ></input>
                                                      :
                                                      <small class="roleTypeSmallText">{name.name}</small>
                                                   }
                                                </div>
                                             </div>
                                             <div class="roleEditDelete" style={{ display: !viewOnly ? "none" : null }}>
                                                <div class="">
                                                   <div id="editDeleteDiv" class="text-right pl-3">
                                                      <div id="announcementdivpadd" >
                                                         <img src={isEdit[index] ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                                            width="22" height="22" class="d-inline-block pr-1" alt="" loading="lazy"
                                                            onClick={() => {
                                                               onEditExternalRole(index);
                                                               recordInitialRoleWisePermission(name.roleId, name.permissions, index, (showDetail[index]));
                                                            }}
                                                         />
                                                      </div>
                                                      <div>
                                                         <img src={require('../../../assets/images/delete_enable.svg')}
                                                            width="22" height="22" class="d-inline-block" alt="" loading="lazy"
                                                            onClick={() => onDeleteExternalRole(index)}
                                                         />
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                          {showDetail[index] && <div class="permissionsOuterDiv">
                                             <div class="permissionsOutline">
                                                <div class="permissionsHeader">
                                                   <div className="functionalityName"><small class="iconNameText">Functionality / Icon Name</small></div>
                                                   <div className="functionalityMeaning"><small class="iconNameText">Functionality Meaning</small></div>
                                                   <div><small class="accessText">Access**</small></div>
                                                </div>
                                                {/* New Approach */}
                                                {name.type != "TPT Internal" && (tileName.map((aname, permissionsIndex) => {
                                                   return (
                                                      <div id="premiumTilePermission">
                                                         <div class="permissionsEvenRows" >
                                                            <div className="functionName">
                                                               <small class="functionsDisplayName">{aname.function}</small>
                                                            </div>
                                                            <div className="functionNameMeaning">
                                                               <small class="functionsDisplayName">{aname.functionMeaning}</small>
                                                            </div>
                                                            <div class="accessRightsMethod">
                                                               {isEdit[index] ? <img src={(data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId).length > 0) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                  id="assignRoleCheckbox"
                                                                  onClick={() =>
                                                                     updateRolePremission(permissionsIndex, index)
                                                                  }
                                                               />
                                                                  :
                                                                  <img src={(data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId).length > 0) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                     id="assignRoleCheckbox" />
                                                               }
                                                            </div>
                                                         </div>
                                                      </div>
                                                   );
                                                }))}
                                                {name.type == "TPT Internal" && (tileName.map((aname, permissionsIndex) => {
                                                   return (
                                                      <>
                                                         <div className="evenrow" id="accessRow">
                                                            <div className="tableRowFunctionName">
                                                               <small className="tileName">{aname.function}</small>
                                                            </div>
                                                            <div className="tableRowFunctionMeaning">
                                                               <small className="tileName">{aname.functionMeaning}</small>
                                                            </div>
                                                            <div className="tableRow">
                                                               <div class="row pr-4" className="tableContainer">
                                                                  <small className="viewEdit">
                                                                     {isEdit ?
                                                                        <img src={(
                                                                           data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId && x.method == "View").length > 0
                                                                        ) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                           onClick={() => {
                                                                              updateRoleViewPremission(permissionsIndex, index)
                                                                           }}
                                                                           className="assignRightCheckbox"
                                                                        />
                                                                        :
                                                                        <img src={(
                                                                           data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId && x.method == "View").length > 0
                                                                        ) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                           className="assignRightCheckbox"
                                                                        />
                                                                     }
                                                                     View
                                                                  </small>
                                                                  <small className="viewEdit">
                                                                     {isEdit ?
                                                                        <img src={(
                                                                           data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId && x.method == "View & Edit").length > 0
                                                                        ) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                           onClick={() => {
                                                                              updateRoleViewEditPremission(permissionsIndex, index)
                                                                           }}
                                                                           className="assignRightCheckbox" /> :
                                                                        <img src={(
                                                                           data[index].permissions.filter(x => x.functionId == tileName[permissionsIndex].functionId && x.method == "View & Edit").length > 0
                                                                        ) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                                           className="assignRightCheckbox" />
                                                                     }
                                                                     View & Edit
                                                                  </small>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </>
                                                   );
                                                }))}
                                                {isEdit[index] && <div className="buttonRow">
                                                   <div class="roleButtonDiv">
                                                      <button class="roleConfirmButton"
                                                         disabled={!validateEditFormFields()}
                                                         onClick={() => confirmHandler(index)}
                                                      ><small class="roleButtonText">Confirm</small></button>
                                                   </div>
                                                </div>}

                                             </div>
                                          </div>}
                                       </div>
                                    </div>
                                 );
                              }))}
                              {addRolename && <div>
                                 <div class="addExternalRoleOuterDiv" id="role">
                                    <div class="rolelinetable">
                                       <div class="roleAccordion">
                                          <img src={addRolename ? require('../../../assets/images/accordion_up.svg') : require('../../../assets/images/accordion_down.svg')} width="21" height="21" id="" class="d-inline-block mt-1" alt="" loading="lazy" />
                                       </div>
                                       <div class="roleTypeDiv">
                                          <input type="text" className="rolelinetableselect" value={roleType} placeholder="- - Select - -" />
                                          <img src={require('../../../assets/images/drpdwnArrow.svg')} onClick={showAddRoleTypeDropdown} width="14" height="18" id="rolelineimg" class="d-inline-block mt-1" alt="" loading="lazy" />
                                          <div>{showRoleTypeDropdown && <div class="roleTypeDropdown" ref={container}>
                                             <div class="roleTypeDropdownOutline">
                                                <div>
                                                   <table class="roleTypeTable">
                                                      <tr onClick={() => {
                                                         setRoleType("Requester");
                                                         setRoleName("");
                                                         setShowRoleTypeDropdown(false)
                                                      }} class="roleTypeDropdownRow"><small class="roleTypeDropdown">Requester</small></tr>
                                                      <tr onClick={() => {
                                                         setRoleType("Respondent");
                                                         setRoleName("");
                                                         setShowRoleTypeDropdown(false)
                                                      }} class="roleTypeDropdownRow"><small class="roleTypeDropdown">Respondent</small></tr>
                                                      <tr onClick={() => {
                                                         setRoleType("Driver");
                                                         setRoleName("");
                                                         setShowRoleTypeDropdown(false)
                                                      }} class="roleTypeDropdownRow"><small class="roleTypeDropdown">Driver</small></tr>
                                                      <tr onClick={() => {
                                                         setRoleType("Preview");
                                                         setRoleName("Preview");
                                                         setShowRoleTypeDropdown(false)
                                                      }} class="roleTypeDropdownRow"><small class="roleTypeDropdown">Preview</small></tr>
                                                      <tr onClick={() => {
                                                         setRoleType("TPT Internal");
                                                         setRoleName("");
                                                         setShowRoleTypeDropdown(false)
                                                      }} class="roleTypeDropdownRow"><small class="roleTypeDropdown">TPT Internal</small></tr>
                                                   </table>
                                                </div>
                                             </div>
                                          </div>}
                                          </div>
                                       </div>
                                       <div class="roleNameDiv"><input class="roleaddinput" placeholder="Enter Role Name" value={roleName} onChange={e => setRoleName(e.target.value)} readOnly={roleName == "Preview" ? true : false} ></input></div>
                                    </div>
                                    <div class="roleEditDelete">
                                       <div class="">
                                          <div id="editDeleteDiv" class="text-right pl-3">
                                             <div id="announcementdivpadd" >
                                                <img src={require('../../../assets/images/editenable.svg')} width="22" height="22" class="d-inline-block pr-1" alt="" loading="lazy" />
                                             </div>
                                             <div>
                                                <img src={require('../../../assets/images/delete_enable.svg')} width="22" height="22" class="d-inline-block" alt="" loading="lazy"
                                                   onClick={() => {
                                                      setAddRolename(false);
                                                      setRoleName('');
                                                      setRoleType('');
                                                   }}
                                                />
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>}
                              {addRolename && roleType != "TPT Internal" && <div class="permissionsOuterDiv">
                                 <div class="permissionsOutline">
                                    <div class="permissionsHeader">
                                       <div className="functionalityName"><small class="iconNameText">Functionality / Icon Name</small></div>
                                       <div className="functionalityMeaning"><small class="iconNameText">Functionality Meaning</small></div>
                                       <div><small class="accessText">Access**</small></div>
                                    </div>
                                    {(tileName.map((aname, index) => {
                                       return (
                                          <div class="permissionsRows">
                                             <div class="tilePermissionsRows">
                                                <div className="functionName">
                                                   <small class="functionsDisplayName">{aname.function}</small>
                                                </div>
                                                <div className="functionNameMeaning">
                                                   <small class="functionsDisplayName">{aname.functionMeaning}</small>
                                                </div>
                                                <div class="accessRightsMethod">
                                                   <img src={(premiumAccess[index]) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                      onClick={() => {
                                                         let a = premiumAccess;
                                                         a[index] = !premiumAccess[index];
                                                         setPremiumAccess(a);
                                                      }}
                                                      id="assignRoleCheckbox" />
                                                </div>
                                             </div>
                                          </div>
                                       );
                                    })
                                    )}
                                    <div className="buttonRow">
                                       <div class="roleButtonDiv">
                                          <button class="roleConfirmButton"
                                             onClick={() => addExternalRole()}
                                             disabled={!validateFormFields()}
                                          ><small class="roleButtonText">Confirm</small></button>
                                       </div>
                                    </div>
                                 </div>
                              </div>}
                              {/* for internal user */}
                              {addRolename && roleType == "TPT Internal" &&
                                 <div class="permissionsOuterDiv">
                                    <div class="permissionsOutline">
                                       <div class="permissionsHeader">
                                          <div className="functionalityNameInternal"><small class="iconNameText">Functionality / Icon Name</small></div>
                                          <div className="functionalityMeaning"><small class="iconNameText">Functionality Meaning</small></div>
                                          <div><small class="accessText">Access**</small></div>
                                       </div>
                                       {tileName.map((name, index) => {
                                          return (
                                             <div className="tileNameRows">
                                                <div className="tableRowFunctionName">
                                                   <small className="tileName">{name.function}</small>
                                                </div>
                                                <div className="tableRowFunctionMeaning">
                                                   <small className="tileName">{name.functionMeaning}</small>
                                                </div>
                                                <div className="tableRow">
                                                   <div class="row pr-4" className="tableContainer">
                                                      <small className="viewEdit">
                                                         <img src={(viewAccess[index]) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                            onClick={() => {
                                                               let a = viewAccess;
                                                               let b = viewEditAccess;
                                                               a[index] = true;
                                                               b[index] = false;
                                                               setViewAccess(a);
                                                               setViewEditAccess(b);
                                                            }}
                                                            className="assignRightCheckbox"
                                                         />
                                   View
                              </small>
                                                      <small className="viewEdit">
                                                         <img src={(viewEditAccess[index]) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="18" height="18" class="d-inline-block"
                                                            onClick={() => {
                                                               let a = viewAccess;
                                                               let b = viewEditAccess;
                                                               a[index] = false;
                                                               b[index] = true;
                                                               setViewEditAccess(b);
                                                               setViewAccess(a);
                                                            }}
                                                            className="assignRightCheckbox" />
                                   View & Edit
                              </small>
                                                   </div>
                                                </div>
                                             </div>
                                          )
                                       })
                                       }
                                       <div className="buttonRow">
                                          <div class="roleButtonDiv">
                                             <button class="roleConfirmButton"
                                                onClick={() => addInternalRole()}
                                                disabled={!validateFormFields()}
                                             ><small class="roleButtonText">Confirm</small></button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              }
                           </div>
                           <div class="externalRolePremiumBottomPart">
                              <div class="rolecolumn">
                                 <a href="#role" onClick={showAddRoleName} style={{ display: !viewOnly ? "none" : null }}>
                                    <img src={addRolename ? require('../../../assets/images/plus_disable.svg') : require('../../../assets/images/add.svg')} width="19" height="19" class="d-inline-block" id="addExternalRoleIcon" alt="" loading="lazy" />
                                    <small class="" id="addNewRoleLink" style={{ color: addRolename ? "#B6B6B6" : "#428BCA" }}>Add New Role</small>
                                 </a>
                                 <div>
                                    <small class="bottomText">* Role Name added here will be visible to external users on CC App under ‘Role Name’ dropdown on ‘Add Profile’ screen</small>
                                 </div>
                                 <div>
                                    <small class="bottomText">** External users will see only those functionalties / icon on their home screen for which access has been provided</small>
                                 </div>
                              </div>

                           </div>
                        </div>}
                  </div>
               </div>
            </div>
            <DeleteAssignRoleModal hasOpen={hasOpen} onClick={onCloseModal}>
               <div className="outerTextDiv">
                  <p className="deleteModalText">If you want to delete this role, please unassign
               it for all the resources in ‘<span className="hilighted">Assign Role</span>’ tile</p>
               </div>
            </DeleteAssignRoleModal>
            <DeleteModal hasOpen={hasOpenDelete} onClick={onCloseDeleteModal} onYesClick={onDeleteRole} >
               <p className="deletemodalText">Do you really want to delete this role?</p>
            </DeleteModal>
            <SameRoleModal hasOpen={sameRoleHasOpen} onClick={onCloseSameRoleModal}>
               <div className="outerTextDiv" id="sameRoleDiv">
                  <p id="addrolerespp1">Requested role name already exists under same Role Type</p>
                  <p id="addrolerespp2" >Please enter different role name </p>
               </div>
            </SameRoleModal>
            <SuccessModal hasOpen={confirmedHasOpen} onClick={onCloseConfirmed}>
               <p className="confirmedText">Confirmed</p>
            </SuccessModal>
         </div>
      </div>
   );
}
export default RoleManagement;